
import axios from 'axios'
// import CookiesManager from './CookiesManager'
// import { cookiesKey } from '../../../constant'
import { getAccessToken } from 'Lib'

export default class MyManager {

	constructor() {

		this.requestMethod = {
			GET: "GET",
			POST: "POST",
			PATCH: "PATCH",
			DELETE: "DELETE",
		}
	}

	async requestAction(options, callback) {
		let isHandleError = true
			, responseData = {
				result: false,
				data: null,
				errors: [],
			}
		try {
			if (!options) {
				throw new Error("Invalid parameters")
			}

			if ("isHandleError" in options && typeof options.isHandleError === "boolean") {
				isHandleError = options.isHandleError
				delete options.isHandleError
			}

			let token = getAccessToken()

			let headers = options.headers
			if (!headers) {
				headers = {
					'Content-Type': 'application/json'
				}
			} else {
				if (!headers["Content-Type"]) {
					headers['Content-Type'] = 'application/json'
				}
			}

			if (!!token && (options.useToken || !("useToken" in options))) {
				headers.Authorization = `Bearer ${token}`
			}
			options.headers = headers

			let res = await axios(options)

			if (!!res.data) {
				if ("value" in res.data) {
					responseData.result = true
					responseData.data = res.data.value
				} else if (!!res.data.code && !!res.data.message) {
					responseData.errors = [
						res.data
					]
				}
			}
			if (callback && typeof callback === "function") {
				callback(responseData)
			}

			return responseData

		} catch (error) {
			const { response } = error
			responseData.result = false
			if (!!response) {
				let status = response.status
					, data = response.data
				if (!!data && !!data.code && !!data.message) {
					responseData.errors = [
						data
					]
				} else {
					responseData.errors = [
						{
							code: status,
							message: "Something went wrong !"
						}
					]
				}
			}
			if (callback && typeof callback === "function") {
				callback(responseData)
			}
		}

		return responseData
	}
}


// WEBPACK FOOTER //
// ./src/core/business/MyManager.js